import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  categoryList: {
    '& html': { overflow: 'auto!important' },

    '&:after': {
      background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 5%, rgb(${theme.palette.black}) 50.8%)`,
      bottom: '20px',
      display: 'block',
      left: 0,
      minHeight: '150px',
      position: 'absolute',
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        content: "''",
      },
    },
    position: 'relative',
    textAlign: 'center',
  },
  categoryListHeading: {
    color: `rgb(${theme.palette.doveGray})`,
    fontSize: '1rem',
    fontWeight: 100,
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.35rem',
    },
  },
  categoryListItems: {
    '-webkit-overflow-scrolling': 'touch',
    listStyleType: 'none',
    margin: '3rem 0 0 0',
    [theme.breakpoints.up('sm')]: {
      maxHeight: '740px',
      overflowY: 'scroll',
    },
  },
  scrollBtn: {
    alignItems: 'center',
    background: 'transparent',
    border: 0,
    bottom: '25px',
    cursor: 'pointer',
    display: 'none',
    justifyContent: 'center',
    margin: '0 auto',
    position: 'relative',
    zIndex: 99,
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
}))

export default useStyles
